// extracted by mini-css-extract-plugin
module.exports = {"mallBanner":"mallBanner_mallBanner__1mtmt"};